<script setup>
import { useTeljoyLogo } from "~/composables/states";

const logo = useLogo();
const teljoyLogo = useTeljoyLogo();
const css = useCss();
const debug = useDebug();
</script>
<template>
  <div class="bg-gray-200 relative min-h-full"
       style="font-family: sofia-pro">

    <main class="relative mx-auto grid lg:grid-cols-4 gap-x-16 xl:gap-x-4">
      <h1 class="sr-only">Checkout</h1>
      <section aria-labelledby="payment-and-shipping-heading"
               class="lg:col-start-1 lg:row-start-1 lg:mx-auto lg:w-full lg:max-w-lg lg:pt-0 bg-navBG shadow-lg"
               :class="{ '': debug }">
        <h2 id="payment-and-shipping-heading"
            class="sr-only">Payment and shipping details</h2>
        <div class="mx-auto lg:px-2 w-full lg:w-auto pb-2">
          <div class="px-4 lg:px-3 pt-6 bg-navBG xl:bg-transparent">
            <a href="#">
              <span class="sr-only">Your Company</span>
              <div class="flex lg:flex-row items-center justify-center">
                <p class="text-slate-500 mr-3">A new way to shop with</p>
                <img class="block h-6 lg:h-10 [@media(max-height:600px)]:h-6 w-auto"
                     :src="logo" />
              </div>
              <div class="flex flex-row justify-center w-100 pt-7">
                <img :src="teljoyLogo"
                     alt="Teljoy Logo"
                     class="h-6 lg:h-12 [@media(max-height:600px)]:h-6 w-auto" />
              </div>
              <!-- <img src="https://tailwindui.com/img/logos/mark.svg?color=indigo&amp;shade=300"
                       alt=""
                       class="h-8 w-auto lg:hidden" /> -->
            </a>
          </div>
        </div>

        <navigation-nav />
      </section>

      <section aria-labelledby="summary-heading"
               class="pb-12 sm:px-2 md:px-10 lg:col-start-2 lg:col-span-3  lg:row-start-1 lg:mx-auto lg:w-full lg:bg-transparent lg:px-4 lg:pt-2"
               :class="{ '': debug }">
        <div class="mx-auto lg:max-w-none lg:px-0 h-full">
          <slot />
        </div>
      </section>


    </main>

    <footer class="flex items-center justify-center">
      <div
           class="mx-auto max-w-7xl py-12 px-4 sm:px-6 md:flex md:items-center md:justify-between lg:px-8">
        <div class="md:order-1">
          <p class="text-center text-base text-gray-400">&copy; {{ new
            Date().getFullYear() }} Flexiown powered by Teljoy</p>
        </div>
      </div>
    </footer>

    <link rel="stylesheet"
          type="text/css"
          :href="css" />
  </div>
</template>